import { AppBrowserModule } from './app/app.browser.module';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';

import {
  defineCustomElements as defineCustomeElementNotifications,
  applyPolyfills
} from '@vestiaire/wc-notification/loader';
import { defineCustomElements as defineCustomeElementPersonalizaton } from '@vestiaire/vc-personalization/loader';
import { defineCustomElements as defineCustomeElementQcReport } from '@vestiaire/vc-qc-report/loader';

if (environment.production) {
  enableProdMode();

  // Little hack to hide console log statements on production build
  // Please note that this trick could also be used to output logs to an
  // external service.
  if (window) {
    window.console.log = function() {};
  }
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    platformBrowserDynamic()
      .bootstrapModule(AppBrowserModule)
      .then(ref => {
        // Ensure Angular destroys itself on hot reloads.
        if (window['ngRef']) {
          window['ngRef'].destroy();
        }
        window['ngRef'] = ref;

        // Otherise, log the boot error
      })
      .catch(err => console.error(err));
  },
  { passive: true }
);

// Keep trailing /
import { Location } from '@angular/common';
Location.stripTrailingSlash = url => url;

if (window) {
  applyPolyfills().then(() => {
    defineCustomeElementNotifications(window);
    defineCustomeElementPersonalizaton(window);
    defineCustomeElementQcReport(window);
  });
}
